// hooks/useS3Upload.js
import { fetchData } from "../api/client";

/** Chama o /uploads/sign e retorna { uploadUrl, fileUrl, key } */
async function signOne(file, { prefix = "products", customName } = {}) {
  const body = {
    filename: customName || file.name,
    contentType: file.type || "application/octet-stream",
    prefix,
  };
  const resp = await fetchData("/uploads/sign", "POST", body);
  if (!resp || !resp.data || !resp.data.uploadUrl || !resp.data.fileUrl) {
    throw new Error("Falha ao assinar upload.");
  }
  return resp.data; // { uploadUrl, fileUrl, key }
}

/** PUT direto no S3 com headers mínimos */
/** PUT direto no S3 com headers mínimos (Content-Type + Cache-Control) */
async function putToS3(uploadUrl, file) {
  // manter este valor sincronizado com o backend (CACHE_POLICY)
  const CACHE_CONTROL = "public, max-age=31536000, immutable";

  const res = await fetch(uploadUrl, {
    method: "PUT",
    // IMPORTANTE: apenas os headers que foram realmente assinados pelo backend
    headers: {
      "Content-Type": file.type || "application/octet-stream",
      "Cache-Control": CACHE_CONTROL,
    },
    body: file,
  });

  if (!res.ok) {
    // tenta ler o corpo da resposta para ter mais contexto no erro
    const text = await res.text().catch(() => "");
    throw new Error(`PUT S3 falhou (${res.status}) ${text}`.trim());
  }

  return res;
}

/** Sobe 1 arquivo. Retorna { url, key } */
export async function uploadOne(file, opts = {}) {
  const { uploadUrl, fileUrl, key } = await signOne(file, opts);
  await putToS3(uploadUrl, file);
  return { url: fileUrl, key };
}

/** Sobe vários arquivos em paralelo (com progresso opcional) */
async function uploadMany(files, opts = {}, onProgress) {
  const list = Array.from(files || []);
  const total = list.length;
  let done = 0;
  const update = () => onProgress && onProgress(done, total);

  const CONCURRENCY = 3;
  const results = [];
  let idx = 0;

  async function worker() {
    while (idx < total) {
      const my = idx++;
      const file = list[my];
      try {
        const r = await uploadOne(file, opts);
        results[my] = { ok: true, ...r };
      } catch (e) {
        results[my] = { ok: false, error: e.message || String(e) };
      } finally {
        done++; update();
      }
    }
  }

  await Promise.all(Array.from({ length: Math.min(CONCURRENCY, total) }, worker));
  return results;
}

export function useS3Upload() {
  return { uploadOne, uploadMany };
}
